import _ from 'lodash';
import { toast } from 'react-toastify';

class Utils {
  static deleteEmptyKeys = (object) => {
    const obj = _.cloneDeep(object);

    for (const propName in obj) {
      if (typeof obj[propName] !== 'boolean' && !obj[propName]) {
        delete obj[propName];
      }
    }

    return obj;
  };

  static keysToCamelCase = (object, exclude = []) => {
    const obj = _.cloneDeep(object);
    const newObj = {};

    for (const propName in obj) {
      newObj[exclude.includes(propName) ? propName : _.camelCase(propName)] = obj[propName];
    }

    return newObj;
  };

  static isEmail = (email) => {
    const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailReg.test(String(email).toLowerCase());
  };

  static keyPressOnlyNumber = (e, past, positiveNumber, maxLength, maxValue) => {
    let { value } = e.target;
    const { selectionStart, selectionEnd } = e.target;
    value = value.replace('%', '');

    const pastValueWithCurrentValue = value.slice(0, selectionStart) + (e?.clipboardData?.getData('text') || '');

    const val = past
      ? pastValueWithCurrentValue
      : (value.length && value.length === value.substring(selectionStart, selectionEnd).length
        ? e.key
        : value.substring(0, selectionStart) + e.key + value.substring(selectionStart, value.length));

    const valueToNumber = +val;
    const firstNumber = val.slice(0, 1);

    if (e.which === 32 || (positiveNumber && +firstNumber === 0)
      || isNaN(valueToNumber) || (maxLength && val.length > maxLength)
      || val.includes('.') || val.includes('e') || (maxValue && valueToNumber > maxValue)) {
      e.preventDefault();
    }
  };

  static keyPressPhoneNumber = (e, past) => {
    const { selectionStart, selectionEnd, value } = e.target;
    const pastValueWithCurrentValue = value.slice(0, selectionStart) + (e?.clipboardData?.getData('text') || '');

    const val = past
      ? pastValueWithCurrentValue
      : (value.length && value.length === value.substring(selectionStart, selectionEnd).length
        ? value
        : value.substring(0, selectionStart) + e.key + value.substring(selectionStart, value.length));

    if (!/^[0-9()\-+]*$/.test(val)) {
      e.preventDefault();
    }
  };

  static keyPressCurrency = (e, past, maxValue, countOfDigitsAfterDot, negativeNumber) => {
    if (e.which === 13) {
      return;
    }

    const {
      selectionStart,
      selectionEnd,
      value,
    } = e.target;
    const pastValueWithCurrentValue = value.slice(0, selectionStart) + e?.clipboardData?.getData('text');

    const val = past
      ? pastValueWithCurrentValue
      : (value.length === value.substring(selectionStart, selectionEnd).length
        ? e.key
        : value.substring(0, selectionStart) + e.key + value.substring(selectionStart, value.length));

    const currentVal = negativeNumber && val.slice(0, 1) === '-' ? val.slice(1) : val;

    const valueToNumber = +currentVal;

    if (e.which === 32 || (currentVal.length > 1 && +currentVal.slice(0, 1) === 0 && currentVal.slice(1, 2) !== '.')
      // eslint-disable-next-line no-restricted-globals
      || (currentVal.slice(1, 2) === '.' && !isNaN(+currentVal.slice(2, currentVal.length)
        .replace('.', 'nun'))
        // eslint-disable-next-line no-restricted-globals
        ? false : isNaN(valueToNumber)) || currentVal.includes('e') || currentVal.includes('+')
      || currentVal.includes('-')
      || (!isNaN(countOfDigitsAfterDot) && currentVal.split('.')?.[1]?.length > countOfDigitsAfterDot)
      || (!isNaN(maxValue) && valueToNumber > +maxValue)) {
      e.preventDefault();
    }
  };

  static typingMaxLength = (e, maxLength, past) => {
    const { value } = e.target;
    const { selectionStart, selectionEnd } = e.target;

    const pastValueWithCurrentValue = value.slice(0, selectionStart) + (e?.clipboardData?.getData('text') || '');

    const currentValue = past
      ? pastValueWithCurrentValue
      : (value.length && value.length === value.substring(selectionStart, selectionEnd).length
        ? e.key
        : value.substring(0, selectionStart) + e.key + value.substring(selectionStart, value.length));

    if (currentValue.length > maxLength) {
      e.preventDefault();
    }
  };

  static formattingCurrency = (number, defaultValue = '-') => (
    number ? new Intl.NumberFormat('us-US').format(number) : defaultValue
  );

  static sortingData = (data = [], sortBy = 'name') => {
    const separatingData = () => {
      const numbers = [];
      const abs = [];

      data.forEach((d) => {
        const v = parseInt(d[sortBy], 10);
        isNaN(v) ? abs.push(d) : numbers.push(d);
      });

      return [..._.sortBy(abs, sortBy), ..._.sortBy(numbers, sortBy)];
    };

    return separatingData();
  };

  static sortingDataByNumber = (data, sortBy = 'name') => {
    const sortByNumber = _.sortBy(data, (o) => +o.name).reverse();
    const byKey = (key) => (o) => {
      const v = parseInt(o[key], 10);
      return isNaN(v) ? o[key].toLowerCase() : v;
    };

    return _.sortBy(sortByNumber, byKey(sortBy));
  };

  static animateScrollTo = (querySelector, verticalOffset = 0) => {
    const { top } = document.querySelector(querySelector)?.getBoundingClientRect() || { top: 0 };

    window.scrollBy({
      top: top + verticalOffset,
      left: 0,
      behavior: 'smooth',
    });
  };

  static onUploadFile = (e, callback, validationTypes = '', maxFileSize = null) => {
    const { files } = e.target;

    if (_.isEmpty(files)) {
      return false;
    }

    const validTypes = validationTypes.replaceAll('.', '').split(', ')
      .map((t) => {
        if (t === 'docx') {
          return t.replace('docx', 'officedocument.wordpro');
        }

        if (t === 'doc') {
          return t.replace('doc', 'msword');
        }

        if (t === 'odt') {
          return t.replace('odt', 'opendocument.text');
        }

        if (t === 'xlsx' || t === 'xlsm' || t === 'xls' || t === 'xlt') {
          return 'vnd';
        }

        return t;
      });

    _.forEach(files, (file) => {
      if (!validTypes || validTypes.find((t) => file?.type.includes(t))) {
        if (maxFileSize && Math.ceil(file.size / 1024 / 1024) > maxFileSize) {
          return toast.error(`File max size mast be ${maxFileSize}mb`);
        }

        file._preview = URL.createObjectURL(file);

        callback(file);
      } else {
        toast.error(`not valid file type, please upload ${validationTypes.replaceAll('.', '')} files`);
      }
    });

    e.target.value = '';
  };

  static formattingCount(value, priceDecimal = 0) {
    const formatter = Intl.NumberFormat('en', {
      minimumFractionDigits: priceDecimal,
      maximumFractionDigits: priceDecimal,
    });

    return formatter.format(value);
  }

  static popupWindow = (url, title, width, height) => {
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);
    const params = {
      toolbar: 'no',
      location: 'no',
      directories: 'no',
      status: 'no',
      menubar: 'no',
      scrollbars: 'no',
      resizable: 'no',
      copyhistory: 'no',
      width,
      height,
      top,
      left,
    };
    return window.open(url, title, _.map(params, (v, k) => `${k}=${v}`).join(', '));
  };
}

export default Utils;
